/**
 * Rides Service Hooks
 * React hooks for accessing Rides Management services.
 */
import { useCCMS } from '../useCCMS';
/** Access all Rides Management services. */
export function useRidesServices() {
    const { services } = useCCMS();
    if (!services?.rides) {
        throw new Error('Rides services not available. Ensure CCMSProvider is configured.');
    }
    return services.rides;
}
export function useRidesLookupsService() {
    return useRidesServices().lookups;
}
export function useRidesMeService() {
    return useRidesServices().me;
}
export function useRidesAvailabilityService() {
    return useRidesServices().availability;
}
export function useRidesMatchesService() {
    return useRidesServices().matches;
}
export function useRidesBookingsService() {
    return useRidesServices().bookings;
}
export function useRidesSecurityService() {
    return useRidesServices().security;
}
export function useRidesAdminService() {
    return useRidesServices().admin;
}
export function useRidesSettingsService() {
    return useRidesServices().settings;
}
//# sourceMappingURL=useRidesServices.js.map